// src/hooks/usePrimaryClick

import { useCallback } from 'react'
import moment from 'moment-timezone'
import _ from 'lodash'
import { setError } from '../../../store/new-visit/NewVisitActions'
import { getPatientCreditCards, bookVisit } from '../../../store/new-visit/NewVisitThunk'
import { errorCodes, getUserFriendlyErrorMessage } from '../../../utils/errormessages'
import { text } from '../Constants'
import { MAX_VISIT_PRICE } from '../../../utils/constants'
import { getVisitMethodFromMethodOption } from '../components/visit-information/VisitMethods'
import { useAdyenIsEnabled } from './useAdyenIsEnabled'
import { useAutoUpdatingRef } from '@quickmd-llc/frontend-utils'

export const usePrimaryClick = ({
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  showReviewBook,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  selectedVisit,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  visitOptions,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  selectedPatient,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  dispatch,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  cardMethod,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  price,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  patientVisitCredit,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  state,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  currentTimeZone,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  setPriceError,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  setMethodCardError,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  setTimeError,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  setDateError,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  setVisitError,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  setMethodError,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  setStateError,
  isCoveredByPackage = false,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  setFullNameError,
}) => {
  const { adyenIsEnabled } = useAdyenIsEnabled()
  const adyenIsEnabledRef = useAutoUpdatingRef(adyenIsEnabled)
  const handlePrimaryClick = useCallback(() => {
    if (!showReviewBook) {
      // Reset errors
      setPriceError('')
      setMethodCardError('')

      let errorsFound = false

      // Validate patient selection
      if (!selectedPatient) {
        errorsFound = true
        setFullNameError(getUserFriendlyErrorMessage(errorCodes.SELECT_PATIENT_REQUIRED))
      }

      // Validate time
      if (!visitOptions.time && !state?.useDateTime) {
        errorsFound = true
        setTimeError(getUserFriendlyErrorMessage(errorCodes.FIELD_REQUIRED, null, text.TIME))
      } else if (moment().isAfter(moment(visitOptions.date))) {
        // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
        errorsFound = 'date'
        if (moment().startOf('day').isSame(moment(visitOptions.date).startOf('day'), 'day')) {
          setTimeError(getUserFriendlyErrorMessage(errorCodes.INVALID_VISIT_TIME))
        } else {
          setDateError(getUserFriendlyErrorMessage(errorCodes.INVALID_VISIT_TIME))
        }
      }

      // Validate service visit name
      if (!visitOptions.serviceVisitName) {
        errorsFound = true
        setVisitError(getUserFriendlyErrorMessage(errorCodes.FIELD_REQUIRED, null, text.VISIT_TYPE))
      }

      // Validate method
      if (!visitOptions.method) {
        errorsFound = true
        setMethodError(getUserFriendlyErrorMessage(errorCodes.FIELD_REQUIRED, null, text.METHOD))
      }

      // Validate state
      if (!visitOptions.state) {
        errorsFound = true
        setStateError(getUserFriendlyErrorMessage(errorCodes.FIELD_REQUIRED, null, text.BOOKING_STATE))
      }

      if (errorsFound) {
        // @ts-expect-error TS2367 -- MIGRATION: not approved, fix when encountered
        if (errorsFound === 'date') {
          dispatch(setError(getUserFriendlyErrorMessage(errorCodes.CAN_NOT_SELECT_VISIT_TIME), state.bookingId))
        } else {
          dispatch(setError(getUserFriendlyErrorMessage(errorCodes.FILL_ALL_FIELDS), state.bookingId))
        }
      } else {
        dispatch(getPatientCreditCards(selectedPatient.PatientId, state.bookingId, adyenIsEnabledRef.current))
      }
    } else {
      // Review Book Validation
      let errorsFound = false

      if (moment().isAfter(moment(visitOptions.date))) {
        // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
        errorsFound = 'date'
        if (moment().startOf('day').isSame(moment(visitOptions.date).startOf('day'), 'day')) {
          setTimeError(getUserFriendlyErrorMessage(errorCodes.INVALID_VISIT_TIME))
        } else {
          setDateError(getUserFriendlyErrorMessage(errorCodes.INVALID_VISIT_TIME))
        }
      }

      if (!cardMethod && price > patientVisitCredit && !isCoveredByPackage) {
        // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
        errorsFound = 'card'
        setMethodCardError(getUserFriendlyErrorMessage(errorCodes.CREDIT_CARD_MISSING))
      }

      if (price === '') {
        errorsFound = true
        setPriceError(getUserFriendlyErrorMessage(errorCodes.FIELD_REQUIRED, null, text.VISIT_COST))
      }

      if (price > MAX_VISIT_PRICE) {
        errorsFound = true
        // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
        setPriceError(getUserFriendlyErrorMessage(errorCodes.BIG_VALUE, null, MAX_VISIT_PRICE))
      }

      if (errorsFound) {
        // @ts-expect-error TS2367 -- MIGRATION: not approved, fix when encountered
        if (errorsFound === 'date') {
          dispatch(setError(getUserFriendlyErrorMessage(errorCodes.CAN_NOT_SELECT_VISIT_TIME), state.bookingId))
          // @ts-expect-error TS2367 -- MIGRATION: not approved, fix when encountered
        } else if (errorsFound === 'card') {
          dispatch(setError(getUserFriendlyErrorMessage(errorCodes.MUST_ADD_CREDIT_CARD_TOAST), state.bookingId))
        } else {
          dispatch(setError(getUserFriendlyErrorMessage(errorCodes.FILL_ALL_FIELDS), state.bookingId))
        }
      } else {
        dispatch(
          bookVisit(
            {
              ProviderId: state.provider.providerId,
              PatientId: selectedPatient.PatientId,
              ServiceTypeId: selectedVisit.ServiceTypeId,
              VisitTypeId: selectedVisit.VisitTypes.VisitTypeId,
              TimeZone: state.customTimeZone || currentTimeZone,
              Method: getVisitMethodFromMethodOption(visitOptions.method),
              StateCode: visitOptions.state.split(' ').pop(),
              DateTime: visitOptions.date,
              Price: Number(price),
              CreditCardId: cardMethod?.Id || null,
              VisitCreditAmount: patientVisitCredit > price ? Number(price) : Number(patientVisitCredit),
            },
            state.bookingId,
            selectedPatient.PatientId,
            adyenIsEnabledRef.current,
          ),
        )
      }
    }
  }, [
    showReviewBook,
    selectedVisit,
    visitOptions,
    selectedPatient,
    dispatch,
    cardMethod,
    price,
    patientVisitCredit,
    isCoveredByPackage,
    state,
    currentTimeZone,
    setPriceError,
    setMethodCardError,
    setTimeError,
    setDateError,
    setVisitError,
    setMethodError,
    setStateError,
    setFullNameError,
  ])

  return handlePrimaryClick
}
